export default {
  priv: 'pr_manage',
  overviewTitle: 'ApiEvents',
  detailTitle: 'ApiEvent',
  deleteTitle: 'dit event',
  url: '/manage/apievents',
  apiUrl: '/apievents/',
  sortBy: ['timestamp'],
  sortDesc: [true],
  deletable: false,
  editable: true,
  filterName: 'apievents',
  quickFilter: {
    text: 'Zoek op timestamp',
    value: 'timestamp',
    type: 'text'
  },
  newRecord: {
    is_active: true
  },
  isReadOnlyOverview: true,
  customEditable(item) {
    return false;
  },
  customDeletable(item) {
    return true;
  },
  tableFields: [
    {
      text: 'TimeStamp',
      value: 'timestamp',
      link: '/manage/apievents/{id}',
      width: '10%'
    },
    {
      text: 'User',
      value: 'user_full_name',
      width: '10%'
    },
    {
      text: 'Method',
      value: 'method',
      width: '10%'
    },
    {
      text: 'URL',
      value: 'url',
      width: '10%'
    }
    // {
    //   text: 'Headers',
    //   value: 'headers',
    //   width: '10%'
    // }
  ]
};
